import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Launcher from "./Launcher";
import Home from "./Home";
import "./App.css";

// Read env vars for on-screen troubleshooting banner
const _clientId = process.env.REACT_APP_CLIENT_ID || '<undefined>';
const _serverUrl = process.env.REACT_APP_SERVER_URL || '<undefined>';

export default function App() {

    return (
        <div className="app-shell">
            <div className="env-banner" role="status">
                <span className="env-banner__item">
                    <strong>Client ID:</strong> {_clientId}
                </span>
                <span className="env-banner__divider">|</span>
                <span className="env-banner__item">
                    <strong>Server URL:</strong> {_serverUrl}
                </span>
            </div>
            <div className="app-content">
                <BrowserRouter>
                    <Routes>
                        <Route path="/app" element={<Home/>}/>
                        <Route path="/" element={<Launcher/>} exact/>
                    </Routes>
                </BrowserRouter>
            </div>
        </div>
    );
}
